import React from "react";
import FooterOne from "../common/footer/FooterOne";
import HeaderOne from "../common/header/HeaderOne";
import SectionTitle from "../elements/section-title/SectionTitle";
import SEO from "../common/SEO";
import CounterUpTwo from "../component/counterup/CounterUpTwo";
import AboutThree from "../component/about/AboutThree";
import CertificateGridCard from "../component/certificate/CertificateGridCard";
import BreadCrumbOne from "../elements/breadcrumb/BreadCrumbOne";
import ClientSlider from "../component/client/ClientSlider";
import AccreditationsGallery from "../component/AccreditationsGallery/AccreditationsGallery";

const Certification = () => {
  return (
    <>
      <SEO title="Accreditations" />
      <main className="main-wrapper">
        <HeaderOne />
        <BreadCrumbOne
          subtitle="Commitment to excellence through globally recognized standards"
          title="Leading with Certified Expertise"
          page="Accreditations"
        />

        <CertificateGridCard />
        <AccreditationsGallery />

        <CounterUpTwo />
        <AboutThree />
        <div className="container " style={{ paddingTop: "100px" }}>
          <SectionTitle
            subtitle="Our Clients"
            title="Our valued partners"
            textAlignment="heading-left mb--40"
            textColor=""
          />
        </div>

        <ClientSlider
          itemShow={4}
          colSize="col-md-3"
          columnGap="row-35"
          parentClass="your-custom-class"
        />

        <FooterOne parentClass="" />
      </main>
    </>
  );
};

export default Certification;
